export default "__VITE_ASSET__wivHZsIH__"